import { api } from '@/shared/api/axios'
import type { ApiResponse } from '@/shared/types/auth.types'

export interface MessageDTO {
  id: number
  senderId: number
  senderName?: string
  receiverId: number
  receiverName?: string
  subject: string
  content: string
  read?: boolean
  readAt?: string | null
  createdAt?: string
}

export interface MessageCreateInput {
  senderId: number
  receiverId: number
  subject: string
  content: string
}

export const messageService = {
  getById: async (id: number): Promise<MessageDTO> => {
    const res = await api.get<ApiResponse<MessageDTO>>(`/messages/${id}`)
    return res.data.data
  },

  getReceived: async (receiverId: number): Promise<MessageDTO[]> => {
    const res = await api.get<ApiResponse<MessageDTO[]>>(
      `/messages/received/${receiverId}`
    )
    const data = res.data?.data
    return Array.isArray(data) ? data : []
  },

  getSent: async (senderId: number): Promise<MessageDTO[]> => {
    const res = await api.get<ApiResponse<MessageDTO[]>>(
      `/messages/sent/${senderId}`
    )
    const data = res.data?.data
    return Array.isArray(data) ? data : []
  },

  getUnreadCount: async (receiverId: number): Promise<number> => {
    const res = await api.get<ApiResponse<number>>(
      `/messages/received/${receiverId}/unread/count`
    )
    const data = res.data?.data
    return typeof data === 'number' ? data : 0
  },

  create: async (data: MessageCreateInput): Promise<MessageDTO> => {
    const res = await api.post<ApiResponse<MessageDTO>>('/messages', data)
    return res.data.data
  },

  markAsRead: async (id: number): Promise<MessageDTO> => {
    const res = await api.patch<ApiResponse<MessageDTO>>(`/messages/${id}/read`)
    return res.data.data
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/messages/${id}`)
  },
}
